import {Component} from '@angular/core';
import {RouterModule} from '@angular/router';
import {WaButtonDirective} from 'angular-awesome';
import {WaTextDirective} from 'angular-awesome';
import {WaDetailsDirective} from 'angular-awesome';
import {MarkdownComponent} from 'ngx-markdown';
@Component({
	selector:'jwebmp-comp-pro-wa-scatter-chart',
	templateUrl:'./WaScatterChartProPage.html',
	styles: [],
	styleUrls:['./WaScatterChartProPage.scss'
],
	viewProviders:[],
	animations:[],
	providers:[],
	schemas:[],
	preserveWhitespaces:true,
	host:{},
	imports:[
		RouterModule,
		WaButtonDirective,
		WaTextDirective,
		WaDetailsDirective,
		MarkdownComponent,
],
	standalone:true
})
export class WaScatterChartProPage
{
	mdContent_441 = `\`\`\`java
import com.jwebmp.webawesomepro.components.chart.WaScatterChart;
\`\`\``;
	mdContent_442 = `\`\`\`java
new WaScatterChart<>()
\`\`\``;
}
